module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "scroll-in-view-once",
      rawName: "v-scroll-in-view-once",
      value: (_vm.scrollIn),
      expression: "scrollIn"
    }],
    staticClass: "m-card-videp-wrapper"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.error && !_vm.videoLoaded),
      expression: "!error && !videoLoaded"
    }],
    staticClass: "m-spinner"
  }, [_c('img', {
    attrs: {
      "src": _vm.loading
    }
  })]), _vm._v(" "), _c('video', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.error && _vm.videoLoaded),
      expression: "!error && videoLoaded"
    }, {
      name: "scroll-out-view",
      rawName: "v-scroll-out-view",
      value: (_vm.scrollOut),
      expression: "scrollOut"
    }],
    ref: "video",
    class: ['m-card-video', {
      'paused': _vm.paused
    }],
    attrs: {
      "src": _vm.presrc,
      "controls": _vm.isIPhone
    },
    on: {
      "click": _vm.play
    }
  }), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "c-va-m"
  }, [_c('img', {
    attrs: {
      "src": _vm.icons.del
    }
  }), _vm._v(" "), _c('span', [_vm._v("[视频资源]加载失败")]), _vm._v(" "), _c('span', {
    staticClass: "c-blue",
    on: {
      "click": _vm.reload
    }
  }, [_vm._v("重新加载")])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canvasSupported && _vm.beforePlay && !_vm.error),
      expression: "canvasSupported && beforePlay && !error"
    }],
    staticClass: "firstFrame",
    on: {
      "click": _vm.play
    }
  }, [_c('canvas', {
    ref: "canvas"
  }), _vm._v(" "), _c('div', {
    staticClass: "m-card-video-controls"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isIPhone && _vm.duration),
      expression: "!isIPhone && duration"
    }],
    staticClass: "m-card-video-dutation fz13"
  }, [_vm._v(_vm._s(_vm.duration))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.icons.pause
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.videoLoaded && (_vm.paused || _vm.ended) && !_vm.isIPhone),
      expression: "videoLoaded && (paused || ended) && !isIPhone"
    }],
    staticClass: "firstFrame",
    on: {
      "click": _vm.play
    }
  }, [_c('div', {
    staticClass: "m-card-video-controls"
  }, [_c('img', {
    attrs: {
      "src": _vm.icons.pause
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-a651d934"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/card/cardVideo.vue
// module id = 213
// module chunks = 1